import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const RouteScrollManager = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (typeof window === 'undefined' || !('scrollRestoration' in window.history)) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    if (typeof window === 'undefined' || navigationType === 'POP') {
      return;
    }

    window.scrollTo(0, 0);
  }, [location.pathname, location.search, navigationType]);

  return null;
};

export default RouteScrollManager;
